import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();

  return (
    <section className="gradient-bg text-white py-16">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Business?</h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto">Let's discuss how we can build a custom solution that meets your specific needs and budget.</p>
        <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
          <button 
            onClick={() => navigate('/contact')} 
            className="bg-white text-blue-600 hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300"
          >
            Contact Us
          </button>
          <button 
            onClick={() => navigate('/quote')} 
            className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 px-6 py-3 rounded-md font-medium transition duration-300"
          >
            Get a Free Quote
          </button>
        </div>
      </div>
    </section>
  );
}